<template>
  <div
    v-if="justView || addQuestionTemplate === 'default'"
    class="metrics-reviews"
  >
    <div class="row">
      <div
        class="col-xl-8 mt-auto mb-auto five-star-text"
        :style="{
          color: textColor || '#000000',
        }"
      >
      <span :class="`${this.$route.fullPath.includes('treatments') ? 'text-addquestion' : ''}`"> {{ text }} </span>
      </div>
      <div v-if="justView" class="col-xl-4 text-center position-review">
        <star-rating
          style="width: 335px;"
          :show-rating="false"
          :star-size="30"
          :read-only="true"
          :rating="selected"
        ></star-rating>

        <applicable
          v-if="reviewAnswer === -1"
          :itemId="index"
          :justView="justView"
        />
      </div>
      <div v-else class="col-xl-4 text-center mt-auto mb-auto">
        <div class="apply-review">
          <star-rating
            :show-rating="false"
            :star-size="30"
            :rating="selected"
            v-model="review"
            @rating-selected="update((unSelect = !unSelect))"
          ></star-rating>
          <applicable
            v-if="applicableEnabled"
            v-model="applicabled"
            :itemId="index"
            :selectedButton="selectedButton"
            @click.native="selectedButton = !selectedButton"
            :lang="lang"
          />
        </div>
      </div>
    </div>

    <comment-area v-if="commentEnabled" v-model="comment" />

    <p
      v-if="hasComment && justView"
      class="comment-area"
      :style="{
        color: textColor || '#000000',
      }"
    >
      Comentário: {{ hasComment }}
    </p>

    <hr />
  </div>

  <div v-else>
    <div class="metrics-reviews">
      <div class="row">
        <div
          class="col-xl-12 mt-auto mb-auto five-star-text align-center"
          :style="{
            color: textColor || '#000000',
          }"
        >
          {{ text }}
        </div>

        <div class="col-xl-12 mt-auto mb-auto" style="display: flex; flex-direction: row; align-items: center; justify-content: center">
          <div class="apply-review" style="display: flex; flex-direction: row; align-items: center; justify-content: center">
            <star-rating
              :show-rating="false"
              :star-size="iconSize"
              :rating="selected"
              v-model="review"
              @rating-selected="update((unSelect = !unSelect))"
            ></star-rating>
            <applicable
              v-if="applicableEnabled"
              v-model="applicabled"
              :itemId="index"
              :selectedButton="selectedButton"
              @click.native="selectedButton = !selectedButton"
            />
          </div>
        </div>
      </div>

      <comment-area
        :clickButton="expandComment"
        :template="addQuestionTemplate"
        v-if="commentEnabled"
        v-model="comment"
      />

      <p
        v-if="hasComment && justView"
        class="comment-area"
        :style="{
          color: textColor || '#000000',
        }"
      >
        Comentário: {{ hasComment }}
      </p>

      <hr />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import starRating from 'vue-star-rating';
import commentArea from '../comment-area';
import applicable from '../applicable';

export default {
  name: 'StarRating',
  components: {
    starRating,
    commentArea,
    applicable,
  },
  props: {
    text: { type: String, required: true },
    textColor: { type: String, required: false },
    itemId: { type: String, required: true },
    index: { type: Number, required: true },
    idQuestion: { type: String, required: true },
    justView: { type: Boolean, default: false },
    commentEnabled: { type: Boolean, default: false },
    applicableEnabled: { type: Boolean, default: false },
    selected: { type: Number },
    hasComment: { type: String, default: null },
    reviewAnswer: { type: Number, required: false },
    addQuestionTemplate: { type: String, required: true, default: 'default' },
    lang: { type: String, default: 'br' }
  },
  data: () => ({
    position: null,
    review: null,
    comment: null,
    lastRate: null,
    applicabled: null,
    selectedButton: false,
    unSelect: false,
    expandComment: false,
    oldValue: null,
    iconSize: 40,
  }),
  watch: {
    comment: function watchComment() {
      this.update(false);
    },
    applicabled: function watchApplicated(value) {
      this.$emit('input', {
        review: value,
        position: this.itemId,
        _id: this.idQuestion,
      });
    },
    selectedButton: function watchSelectedButton(value) {
      if (value) {
        this.review = null;

        this.$emit('input', {
          review: -1,
          comment: this.comment,
          position: this.itemId,
          _id: this.idQuestion,
        });
      }
    },
    review: function watchReview(value) {
      this.review = value;
      this.oldValue = value;
    },
  },
  computed: {
    ...mapState('research', ['reviewsReview']),
  },
  methods: {
    getViewSize() {
      this.iconSize = (window.innerWidth) > 350 ? 45 : 30;
    },
    update() {
      this.selectedButton = false;

      this.expandComment = true;

      if (!this.unSelect) {
        // this.review = null;
        this.expandComment = false;
      }

      if (this.review === this.oldValue) {
        /* Observação: foi comentado a linha abaixo porque causou um bug 
        / que limpa a nota do review após escrever um comentário quando habilitado
        */
       //this.review = null;
      }

      this.oldValue = this.review;

      this.$emit('input', {
        review: this.review,
        comment: this.comment,
        position: this.itemId,
        _id: this.idQuestion,
      });
    },
  },
  mounted() {
    this.position = this.$store.state.research.reviewsControl;
    this.$store.state.research.reviewsControl += 1;

    const buttonsNotApply = document.querySelectorAll('.apply-review');

    if (this.applicableEnabled) {
      for (let index = 0; index < buttonsNotApply.length; index += 1) {
        buttonsNotApply[index].style.display = 'inline-flex';
      }
    } else {
      for (let index = 0; index < buttonsNotApply.length; index += 1) {
        buttonsNotApply[index].style.display = 'block';
      }
    }

    if (this.$route.name === 'Detalhes da tratativa') {
      for (let index = 0; index < buttonsNotApply.length; index += 1) {
        buttonsNotApply[index].style.display = 'block';
      }
    }

    window.addEventListener('resize', this.getViewSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getViewSize);
  }
};
</script>

<style lang="scss">
.align-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.position-review {
  display: flex;
  //padding-left: 62px;
  padding-right: 25px;
}

@media only screen and (max-width: 1200px) {
  .metrics-reviews .five-star-text {
    text-align: center;
  }
}

.metrics-reviews .vue-star-rating {
  display: block !important;
  padding: 7px;
}

@media screen and (max-width: 400px) {
  .metrics-reviews .vue-star-rating {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}

.comment-button {
  background: transparent;
  border: 0;
}

.comment-area {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  textarea {
    margin-top: 8px;
    width: 100%;
  }
}

.comment-area {
  font-style: italic;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/metrics/reviews/index.vue